import { useContext } from 'react';
import { ToastContext } from '../components/ui/Toast.js';
export function useToast() {
  return useContext(ToastContext);
}
